import type { ApiRoute, NoQueryParams } from "../../api"
import type { WarrantyPublicOfferView } from "./WarrantyPublicOfferView"

export interface PutWarrantyPublicOfferPathParams {
	inventoryId: string
}

export interface PutWarrantyPublicOfferBody {
	dealerDecisionPorscheApproved: boolean
}

export const putWarrantyPublicOfferRoute: ApiRoute<
	PutWarrantyPublicOfferPathParams,
	NoQueryParams,
	PutWarrantyPublicOfferBody,
	WarrantyPublicOfferView
> = {
	buildUrl: (params) => `/vehicles/${params.inventoryId}/warranty/public-offer`,
	method: "put",
	path: "/vehicles/:inventoryId/warranty/public-offer",
}
